import { AxiosResponse } from 'axios';
import { call, takeLatest, select, put } from 'redux-saga/effects';
import { makeBackendApi } from 'services/BackendApi';
import {
  OfferHotelUuidChangeAction,
  offerHotelUuidChangeSuccessAction,
  OFFER_HOTEL_UUID_CHANGE,
} from '../subdomains/offer/actions';
import { selectedTaSelector } from '../../agents';

export function* getHotelDataSaga(action: OfferHotelUuidChangeAction) {
  try {
    const selectedTa = yield select(selectedTaSelector);
    const backendApi = makeBackendApi(selectedTa?.uuid);
    const result: AxiosResponse<any> = yield call(backendApi.getHotel, action.hotelUuid, [
      'accommodationProducts',
      'fineProducts',
      'transferProducts',
      'groundServiceProducts',
      'mealPlanProducts',
      'supplementProducts',
      'offers',
    ]);
    yield put(offerHotelUuidChangeSuccessAction(result.data.data));
  } catch (e) {
    throw e;
  }
}

export function* watchOfferHotelUuidChangeAction() {
  yield takeLatest(OFFER_HOTEL_UUID_CHANGE, getHotelDataSaga);
}
